module.exports = __webpack_public_path__ + "static/media/BTC.e67e3bff.svg";